import { Observable, OperatorFunction } from 'rxjs';
import { filter, map } from 'rxjs/operators';

function isDefined<T>(value: T): boolean {
  return value !== undefined && value !== null;
}

export function filterNullUndefined<T>(): OperatorFunction<T | undefined | null, T> {
  return function (source: Observable<T | undefined | null>): Observable<T> {
    return source.pipe(
      filter(isDefined),
      map((value: T | undefined | null) => value as T)
    );
  };
}
